import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { getHero, imageUrl } from "../lib/api";
import NoSaveImage from "../components/NoSaveImage";
import Seo from "../components/Seo";

export default function Home() {
  const [hero, setHero] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const prefersReducedMotion = useReducedMotion();
  const { scrollY } = useScroll();
  const parallaxY = useTransform(scrollY, [0, 800], [0, prefersReducedMotion ? 0 : 120]);
  const parallaxScale = useTransform(scrollY, [0, 600], [1.02, prefersReducedMotion ? 1.02 : 1.1]);

  useEffect(() => {
    let alive = true;
    getHero()
      .then((p) => alive && setHero(p))
      .catch(() => {});
    return () => (alive = false);
  }, []);

  return (
    <main
      data-testid="home-page"
      className="relative min-h-screen bg-[color:var(--bg)] text-white grain"
    >
      <Seo path="/" />
      <section className="relative min-h-screen overflow-hidden">
        <motion.div
          style={{ y: parallaxY, scale: parallaxScale }}
          className="absolute inset-0"
        >
          {hero && (
            <NoSaveImage
              data-testid="home-hero-image"
              src={imageUrl(hero.image)}
              alt={hero.alt || ""}
              onLoad={() => setLoaded(true)}
              className={`w-full h-full object-cover transition-opacity duration-[1600ms] ${
                loaded ? "opacity-100" : "opacity-0"
              }`}
              style={{ filter: "brightness(0.86)" }}
            />
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-[color:var(--bg)]/85 via-[color:var(--bg)]/10 to-[color:var(--bg)]/40" />
        </motion.div>

        {/* Discreet identity — bottom left */}
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: loaded ? 1 : 0, y: loaded ? 0 : 8 }}
          transition={{ duration: 1.2, delay: 0.4, ease: [0.2, 0.7, 0.1, 1] }}
          className="absolute left-6 md:left-10 bottom-8 md:bottom-10 z-10"
        >
          {/* Photographer identity. */}
          <p
            data-testid="home-identity"
            className="font-serif-display italic text-white/75 text-base md:text-lg"
          >
            Carol Lines
          </p>
        </motion.div>

        {/* Quiet invitation — bottom right */}
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: loaded ? 1 : 0, y: loaded ? 0 : 8 }}
          transition={{ duration: 1.2, delay: 0.7, ease: [0.2, 0.7, 0.1, 1] }}
          className="absolute right-6 md:right-10 bottom-8 md:bottom-10 z-10"
        >
          <Link
            to="/explore"
            data-testid="home-explore-link"
            className="font-serif-display italic text-white/80 hover:text-white text-lg md:text-xl choice-line"
          >
            Explore
          </Link>
        </motion.div>
      </section>
    </main>
  );
}
